import { BETSLIP_STORAGE_KEY } from 'bto-models/betslip';
import { state } from "../state";
import LocalStorageService from '@bto-services/storage/local-storage-service';
import { toastStore } from '@bto-services/toast-notification';

const currencyStore = {
	roundDigits: 2,
};

/**
 * Function to save betslip state to localstorage
 */
export const saveState = () => {
	LocalStorageService.set(BETSLIP_STORAGE_KEY, state);
};

/**
 * Get item hash key
 * @param {import('bto-models/betslip/interfaces').BetslipItemKey} item - betslip item
 */
export const getItemHashKey = (item) => `${item.matchId}_${item.marketId}_${item.outcomeId}`;

/**
 * Set decimal rounding places
 * @param {number} num - rounding decimal places
 */
export function setRoundingDigits(num) {
	currencyStore.roundDigits = num;
}

/**
 * Format number to 2 decimal places
 * @param {number} num - number to check
 */
export function roundAmount(num, noDecimals = false) {
	return Number.parseFloat(num).toFixed(noDecimals ? 0 : currencyStore.roundDigits);
}

/**
 * Get quickbet message for given item, if it exists undefinied otherwise
 * @param {import('bto-models/betslip/interfaces').BetslipItemKey} item - betslip item
 */
export function getQuickbetPlacementMessage(item) {
	const itemKey = getItemHashKey(item);
	return toastStore.messages[`${APP_SETTINGS.player.id}_${itemKey}`];
}